import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getEventsByProgramId } from "../../services/EventService";
import EventCard from "../../components/EventCard"; // make sure this path is correct
import './styles.css'; // your styles including .events-hero-section etc.

export default function EventPage() {
  const [searchParams] = useSearchParams();
  const programId = searchParams.get("program_id");

  const [events, setEvents] = useState([]);

  useEffect(() => {
    async function loadEvents() {
      if (programId) {
        const data = await getEventsByProgramId(programId);
        setEvents(data);
      }
    }
    loadEvents();
  }, [programId]);

  return (
    <div className="events-hero-section">
      <div className="events-content-wrapper">
        <h1 className="events-title">Program Events</h1>
        <p className="events-subtext">
          These events break down into actionable lesson plans designed to help guide mentoring teams.
        </p>
        <div className="event-cards-container">
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </div>
  );
}
